import Vue from 'vue'
import Vuex from 'vuex'
import product from './product'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const VuexPersist = new VuexPersistence({
  storage: window.sessionStorage,
  reducer: (state) => ({
    product: {
      favoriteList: state.product.favoriteList,
      cartList: state.product.cartList
    }
  })
})

// 創建 store 實例
const store = new Vuex.Store({
  modules: {
    product
  },
  // getters,
  plugins: [VuexPersist.plugin]
})

export default store
